/* eslint-disable tailwindcss/no-custom-classname */
/* eslint-disable tailwindcss/no-arbitrary-value */
import type { MouseEventHandler } from 'react';
import Button, { ButtonStyleType, ButtonVariant } from '../../Button';
import { FeLink } from '../../FeLink';
import { MaterialIcon } from '../../MaterialIcon';
import type { ProductGridCardPrimaryCtaIcon } from '../types';

type ProductGridCardCtaProps = {
  label: string;
  href?: string;
  onClick?: MouseEventHandler<HTMLElement>;
  variant?: ButtonVariant;
  styleType?: ButtonStyleType;
  icon?: ProductGridCardPrimaryCtaIcon;
};

const buttonClassName = 'w-full';

export const ProductGridCardCta = ({
  label,
  href,
  onClick,
  variant = 'filled',
  styleType = 'primary',
  icon = 'none',
}: ProductGridCardCtaProps) => {
  const endIcon =
    icon === 'arrow' ? (
      <MaterialIcon
        icon="arrow_forward"
        px={20}
        className="!text-[18px] md:!text-[20px]"
      />
    ) : undefined;

  const button = (
    <Button
      size="small"
      type="button"
      variant={variant}
      styleType={styleType}
      onClick={href ? undefined : onClick}
      className={buttonClassName}
      endIcon={endIcon}
    >
      {label}
    </Button>
  );

  if (!href) {
    return button;
  }

  return (
    <FeLink
      href={href}
      className="no-underline"
      onClick={onClick as MouseEventHandler<HTMLAnchorElement>}
    >
      {button}
    </FeLink>
  );
};
